// Block clinics

$(function () {
  $('.jsBlockClinicsCarousel').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    items: 1,
    smartSpeed: 500,
    autoplay: true,
    autoplayTimeout: 8000,
    autoplayHoverPause: true
  });
})
